export default "__VITE_ASSET__119fd35d__"